import { getUser, signIn, changeUserCulture } from "../../services/user";
import { sendMail, newPassword } from "../../services/passwordReset";

export const setUser = user => ({
  type: "SET_USER",
  user
});

export const logOut = () => ({
  type: "LOGOUT_USER"
});

export const notification = notification => ({
  type: "NOTIFICATION",
  notification
});
export const setLang = data => ({
  type: "SET_LANG",
  data
});
export const setCulture = data => ({
  type: "SET_CULTURE",
  data
});
// Action Creators - Redux Thunk

export const userLogout = () => dispatch => {
  dispatch(logOut());
};

export const userLanguage = ({
  token,
  id,
  name,
  mobile,
  lang,
  dir
}) => dispatch => {
  if (token) {
    changeUserCulture({ token, id, name, mobile }).then(data => {
      // console.log("languagelanguage", data.updateUser.culture);
      dispatch(
        setLang({
          dir: data.updateUser.culture.direction,
          lang: data.updateUser.culture.language,
          id: data.updateUser.culture.id
        })
      );
    });
  } else {
    dispatch(
      setLang({
        dir: dir,
        lang: lang,
        id: id
      })
    );
  }
};

export const userCulture = data => dispatch => {
  dispatch(setCulture(data));
};

export const userFetch = ({ token, setLoading }) => dispatch => {
  getUser(token)
    .then(user => {
      dispatch(setUser({ user }));
      dispatch(
        setLang({
          lang: user.culture.language,
          dir: user.culture.direction
        })
      );
      setLoading(false);
    })
    .catch(() => {
      dispatch(logOut());
      setLoading(false);
    });
};

export const userSignIn = ({
  values,
  handleSignInError,
  captcha,
  notification
}) => dispatch => {
  signIn(values)
    .then(user => {
      // console.log("user", user);
      dispatch(setUser(user));
      // dispatch(
      //   notification({
      //     message: "به سامانه خوش آمدید",
      //     variant: "success"
      //   })
      // );
      notification(true);
    })
    .catch(error => {
      captcha();
      // dispatch(
      //   notification({
      //     message: "ایمیل یا رمز عبور اشتباه است",
      //     variant: "error"
      //   })
      // );
      handleSignInError(error);
    });
};

export const userForgetPassword = ({
  values,
  loading,
  notification
}) => dispatch => {
  sendMail(values)
    .then(e => {
      // console.log("ff", e.sendLink);
      // console.log("ffz", e.json());
      // dispatch(
      //   notification({
      //     message: "لینک تغییر رمز عبور به ایمیل شما ارسال شد",
      //     variant: "success"
      //   })
      // );
      notification(e);
      loading(false);
    })
    .catch(err => {
      // console.log("errr", err);
      notification(null);
      // dispatch(
      //   notification({
      //     message: "ایمیل وارد شده معتبر نیست",
      //     variant: "error"
      //   })
      // );
      loading(false);
    });
};
export const userNewPassword = ({
  pass,
  token,
  loading,
  notification
}) => dispatch => {
  newPassword({ pass, token })
    .then(e => {
      // dispatch(
      //   notification({
      //     message: "رمز عبور تغییر یافت انتقال به صفحه اصلی",
      //     variant: "success"
      //   })
      // );
      // console.log("oo", e.updateLink);
      notification(e);
      loading(false);
    })
    .catch(() => {
      // dispatch(
      //   notification({
      //     message: "رمز قادر به تغییر نیست مجددا تلاش نمایید",
      //     variant: "error"
      //   })
      // );
      notification(null);
      loading(false);
    });
};
